// Live Event
export const LIVE_EVENT_PAGE_VIEWED = "live_event_page_viewed";

// Page
export const PAGE_VIEWED = "page_viewed";

// Video playback
export const VIDEO_STARTED = "video_started";
export const VIDEO_PROGRESS = "video_progress";
export const VIDEO_COMPLETED = "video_completed";
export const VIDEO_PAUSED = "video_paused";
export const VIDEO_SEEKED = "video_seeked";
export const VIDEO_CAPTIONS_CHANGED = "video_captions_changed";
export const VIDEO_FULLSCREEN_CHANGED = "video_fullscreen_changed";
export const VIDEO_ENTER_PICTURE_IN_PICTURE = "video_enter_picture_in_picture";
export const VIDEO_LEAVE_PICTURE_IN_PICTURE = "video_leave_picture_in_picture";
export const VIDEO_QUALITY_CHANGED = "video_quality_changed";
export const VIDEO_PLAYBACK_RATE_CHANGED = "video_playback_rate_changed";
export const VIDEO_VOLUME_CHANGED = "video_volume_changed";
export const VIDEO_BUFFER_START = "video_buffer_start";
export const VIDEO_BUFFER_END = "video_buffer_end";

// Video page interactions
export const VIDEO_BACK_CLICKED = "video_back_clicked";
export const VIDEO_SHARE_CLICKED = "video_share_clicked";
export const VIDEO_SHARE_LINK_COPIED = "video_share_link_copied";
export const VIDEO_SIDEBAR_ITEM_SELECTED = "video_sidebar_item_selected";
export const VIDEO_SIMILAR_COURSE_TAB_VIEWED =
  "video_similar_course_tab_viewed";
export const VIDEO_MODULE_COMPLETED = "video_module_completed";
export const VIDEO_MODULE_NAVIGATED_PREVIOUS =
  "video_module_navigated_previous";

// Digital Gym page interactions
export const DIGITAL_GYM_VIEW_SELECTED = "digital_gym_view_selected";
export const DIGITAL_GYM_SERIES_NAVIGATED = "digital_gym_series_navigated";
export const DIGITAL_GYM_TIMETABLE_EVENT_CLICKED =
  "digital_gym_timetable_event_clicked";
export const DIGITAL_GYM_GUIDE_DOWNLOADED = "digital_gym_guide_downloaded";
export const DIGITAL_GYM_CLASS_SEARCHED = "digital_gym_class_searched";
export const DIGITAL_GYM_CLASS_FILTER_CHANGED =
  "digital_gym_class_filter_changed";
export const DIGITAL_GYM_CLASS_SORT_CHANGED = "digital_gym_class_sort_changed";
export const DIGITAL_GYM_CLASS_SELECTED = "digital_gym_class_selected";
export const DIGITAL_GYM_CLASS_PAGE_CHANGED = "digital_gym_class_page_changed";
export const DIGITAL_GYM_TRAINING_PLAN_SELECTED =
  "digital_gym_training_plan_selected";

// Event page interactions
export const EVENT_PAGE_BACK_CLICKED = "event_page_back_clicked";
export const EVENT_PAGE_SHARE_CLICKED = "event_page_share_clicked";
export const EVENT_PAGE_SIDEBAR_ITEM_SELECTED =
  "event_page_sidebar_item_selected";
export const EVENT_PAGE_FAVOURITE_TOGGLED = "event_page_favourite_toggled";
export const EVENT_PAGE_REMIND_ME_TOGGLED = "event_page_remind_me_toggled";
export const EVENT_PAGE_WATCH_LATER_TOGGLED = "event_page_watch_later_toggled";

// App engagement — Intercom campaign triggers (CR-79)
export const APP_OPENED = "app_opened";
export const APP_DOWNLOAD_CLICKED = "app_download_clicked";

// Login / MFA
export const LOGIN_MFA_CODE_RESENT = "login_mfa_code_resent";

// Timezone preference (TD-192) — names mirror react-native-prototype's
// src/utils/analytics/analyticsEvents.ts so web and mobile report as one funnel.
export const SIGNUP_TIMEZONE_SELECTED = "signup_timezone_selected";
export const SETTINGS_TIMEZONE_SELECTED = "settings_timezone_selected";
export const SETTINGS_TIMEZONE_SAVED = "settings_timezone_saved";
export const SETTINGS_TIMEZONE_SAVE_FAILED = "settings_timezone_save_failed";

// EAP
export const EAP_LIVE_CHAT_OPENED = "eap_live_chat_opened";

// Guest join (CR-300) — anonymous, no identifyUser call on this route; never
// carry the join/challenge/session token, phone number, sf_contact_id,
// sf_appointment_id or clinician name as a property.
export const GUEST_JOIN_PAGE_VIEWED = "guest_join_page_viewed";
export const GUEST_JOIN_OTP_SUBMITTED = "guest_join_otp_submitted";
export const GUEST_JOIN_OTP_LOCKED = "guest_join_otp_locked";
export const GUEST_JOIN_EXPIRED = "guest_join_expired";
export const GUEST_JOIN_ROOM_CONNECTED = "guest_join_room_connected";
export const GUEST_JOIN_SESSION_ENDED = "guest_join_session_ended";
